// Build-time configuration (Vite injects VITE_* variables from .env files / CI secrets).
export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;
// Your own routing server (see server/). Falls back to nothing: the app refuses to plan without it.
export const ROUTING_URL = (import.meta.env.VITE_ROUTING_URL || '').replace(/\/$/, '');
export const ROUTING_KEY = import.meta.env.VITE_ROUTING_KEY || '';
export const PLAY_STORE_URL = import.meta.env.VITE_PLAY_STORE_URL || 'https://play.google.com/store/apps/details?id=com.acmeenterprises.routes';
export const APP_VERSION = __APP_VERSION__; // from package.json, injected by vite.config.js

// Map area: Bengaluru
export const MAP_CENTER = [12.9716, 77.5946];
export const MAP_BOUNDS = [[12.75, 77.40], [13.20, 77.85]];
